import moment from 'moment-timezone'
import {Scheduler, UploadHistoryStatus} from '../../../../services/cellcast.type'
import {ContactStatus} from '../../../../services/cellcast.v2.types'

export enum MessageDeliveryStatus {
  BLOCKED = 'blocked',
  DELIVERED = 'delivered',
  FAILED = 'failed',
  RECEIVED = 'received',
  EXPIRED = 'expired',
  QUEUED = 'queued',
  SEND = 'sent',
  REJECTED = 'rejected',
  CANCELED = 'canceled',
  PAUSED = 'paused',
  SCHEDULED = 'scheduled',
}

export enum SchedulerType {
  ONCE = 'once',
}

export enum ScheduleStatus {
  PAUSED = 'paused',
  CANCELLED = 'cancelled',
  SCHEDULED = 'scheduled',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export const MessageDeliveryOptions = [
  {
    value: '',
    label: 'Select Status',
  },
  {
    value: MessageDeliveryStatus.BLOCKED,
    label: MessageDeliveryStatus.BLOCKED.toString().toUpperCase(),
  },
  {
    value: MessageDeliveryStatus.DELIVERED,
    label: MessageDeliveryStatus.DELIVERED.toString().toUpperCase(),
  },
  {
    value: MessageDeliveryStatus.FAILED,
    label: MessageDeliveryStatus.FAILED.toString().toUpperCase(),
  },
  {
    value: MessageDeliveryStatus.RECEIVED,
    label: MessageDeliveryStatus.RECEIVED.toString().toUpperCase(),
  },
  {
    value: MessageDeliveryStatus.EXPIRED,
    label: MessageDeliveryStatus.EXPIRED.toString().toUpperCase(),
  },
  {
    value: MessageDeliveryStatus.QUEUED,
    label: MessageDeliveryStatus.QUEUED.toString().toUpperCase(),
  },
  {
    value: MessageDeliveryStatus.SEND,
    label: MessageDeliveryStatus.SEND.toString().toUpperCase(),
  },
  {
    value: MessageDeliveryStatus.REJECTED,
    label: MessageDeliveryStatus.REJECTED.toString().toUpperCase(),
  },
  {
    value: MessageDeliveryStatus.CANCELED,
    label: MessageDeliveryStatus.CANCELED.toString().toUpperCase(),
  },
  {
    value: MessageDeliveryStatus.PAUSED,
    label: MessageDeliveryStatus.PAUSED.toString().toUpperCase(),
  },

]

export const SchedulerTypeOptions = [
  {
    value: '',
    label: 'Select Status',
  },
  {
    value: ScheduleStatus.CANCELLED,
    label: ScheduleStatus.CANCELLED.toString().toUpperCase(),
  },
  {
    value: ScheduleStatus.COMPLETED,
    label: ScheduleStatus.COMPLETED.toString().toUpperCase(),
  },
  {
    value: ScheduleStatus.SCHEDULED,
    label: ScheduleStatus.SCHEDULED.toString().toUpperCase(),
  },
  {
    value: ScheduleStatus.FAILED,
    label: ScheduleStatus.FAILED.toString().toUpperCase(),
  },
]

export const UploadHistoryOptions = [
  {
    value: '',
    label: 'Select Status',
  },
  {
    value: UploadHistoryStatus.COMPLETED,
    label: UploadHistoryStatus.COMPLETED.toString().toUpperCase(),
  },

  {
    value: UploadHistoryStatus.FAILED,
    label: UploadHistoryStatus.FAILED.toString().toUpperCase(),
  },

  {
    value: UploadHistoryStatus.QUEUED,
    label: UploadHistoryStatus.QUEUED.toString().toUpperCase(),
  },
]

export const visualizeHiddenCharacters = (message: string) => {
  if (!message) return message
  return message
    .replace(/\\n/g, '\\n') // Literal \n
    .replace(/\n/g, '\\n') // Actual newline characters
    .replace(/\\t/g, '\\t') // Literal \t
    .replace(/\t/g, '\\t') // Actual tab characters
}

type CheckScheduled = Pick<Scheduler, 'status' | 'nextExecution' | 'active' | 'messageStatus'>

export const checkIsScheduled = ({
  status,
  nextExecution,
  active,
  messageStatus,
}: CheckScheduled) => {
  const currentDate = moment()
  const executionDate = moment(nextExecution)

  if (messageStatus === ScheduleStatus.FAILED) {
    return ScheduleStatus.FAILED
  }
  if (!active) {
    return ScheduleStatus.CANCELLED
  }

  if (!status && active) {
    return ScheduleStatus.PAUSED
  }

  if (status === true && executionDate.isBefore(currentDate)) {
    return ScheduleStatus.COMPLETED
  }

  if (status === true && executionDate.isAfter(currentDate)) {
    return ScheduleStatus.SCHEDULED
  }

  return ScheduleStatus.COMPLETED
}

export const ContactStatusOptions = [
  {
    value: '',
    label: 'Select Status',
  },
  {
    value: ContactStatus.subscribe,
    label: ContactStatus.subscribe.toString().toUpperCase(),
  },

  {
    value: ContactStatus.unsubscribe,
    label: ContactStatus.unsubscribe.toString().toUpperCase(),
  },
]

export const REQUEST_FORM_TYPE = {
  APP: 'APP',
  EMAIL: 'EMAIL',
  API: 'API',
  BULK: 'BULK',
}

export const REQUEST_FROM = [
  {
    label: 'Quick Message',
    value: 'APP',
  },
  {
    label: 'Email To Sms',
    value: 'EMAIL',
  },
  {
    label: 'API',
    value: 'API',
  },
  {
    label: 'BULK',
    value: 'BULK',
  },
]

export const GATEWAY_LIST = [
  {value: 'Gateway1', label: 'Gateway 1'},
  {value: 'Gateway2', label: 'Gateway 2'},
  {value: 'Gateway3', label: 'Gateway 3'},
  {value: 'Gateway4', label: 'Gateway 4'},
]
